import Vue from 'vue'
import Router from 'vue-router'
import projectListing from './pages/projectListing'
import projectPage from './pages/projectPage'
import blogListing from './pages/blogListing'
import blogPage from './pages/blogPage'

Vue.use(Router)

export default new Router({
  mode: 'history', /* Removes hash from URL */
  routes: [
    {
      path: '/',
      name: 'Index',
      component: projectListing
    },
    {
      path: '/project/:slug',
      name: 'Project',
      component: projectPage
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ "../views/about")
    },
    {
      path: '/blog',
      name: 'Blog List',
      component: blogListing
    },
    {
      path: '/blog/:slug',
      name: 'Blog',
      component: blogPage
    },
    { path: '*', redirect: '/' } /* catch-all */
  ]
})
